<template>
  <div class="step-tab">
    <div class="cp-card">
      <p class="cp-hint">{{ L.travelers_step_hint || 'The Travelers step collects each traveller. The only profile-configurable box is the name-spelling disclaimer below.' }}</p>
      <BoxVisibilityToggle
          :boxVisibility="profile.box_visibility"
          boxKey="name_disclaimer"
          :label="L.review_box_name_disclaimer || 'Name spelling disclaimer'"
          :hint="L.box_toggle_name_disclaimer_hint || 'Passport name-spelling notice + required confirmation checkbox.'" />
    </div>

    <PreviewFrame :label="L.preview || 'Preview'">
      <TravelersPreview :texts="text" :rich="richHtml" :lang="lang" :brandColor="brandColor" :boxVisibility="profile.box_visibility" />
    </PreviewFrame>
  </div>
</template>

<script>
import PreviewFrame from './previews/PreviewFrame.vue'
import TravelersPreview from './previews/TravelersPreview.vue'
import BoxVisibilityToggle from './BoxVisibilityToggle.vue'

/**
 * Travelers step tab: only the name-spelling disclaimer box is profile-configurable
 * (show/hide). The disclaimer's text is edited on the Terms tab; here the admin
 * decides whether the box appears, with a live preview.
 */
export default {
  name: 'StepTabTravelers',
  components: { PreviewFrame, TravelersPreview, BoxVisibilityToggle },
  props: {
    options: { type: Object, required: true },
    profile: { type: Object, required: true },
    text: { type: Object, default: () => ({}) },
    richHtml: { type: Object, default: () => ({}) },
    lang: { type: String, default: 'de' },
    brandColor: { type: String, default: '#1a73e8' }
  },
  computed: {
    L() { return this.options.Lang || {}; }
  }
};
</script>

<style scoped>
.step-tab { animation: cp-fade .2s ease; }
@keyframes cp-fade { from { opacity: 0; transform: translateY(4px); } to { opacity: 1; transform: translateY(0); } }
.cp-card { background: #fff; border-radius: 1rem; box-shadow: 0 2px 12px rgba(0,0,0,0.06); padding: 1.5rem 1.75rem; }
.cp-hint { font-size: 0.8rem; color: #888; margin: 0 0 1rem; max-width: 620px; }
</style>
